import * as React from 'react';

function SvgPhoneIcon(props) {
  return (<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" {...props}>
    <circle cx={10} cy={10} r={10} fill="#DF4046" />
    <path
      stroke="#fff"
      strokeMiterlimit={10}
      d="m15.17 12.738-1.59-1.588a.764.764 0 0 0-1.065 0l-.927.925L7.93 8.41l.927-.925a.76.76 0 0 0 0-1.064l-1.59-1.589a.764.764 0 0 0-1.065 0L5.124 5.907a1.766 1.766 0 0 0 0 2.477l6.489 6.494a1.77 1.77 0 0 0 2.48 0l1.077-1.076a.76.76 0 0 0 0-1.064Z"
    />
  </svg>)
}
export default SvgPhoneIcon;
